import { ChangeDetectionStrategy, Component } from '@angular/core';
import { untranslatedString } from 'models/translated-string';
import { LoadingController } from 'providers/loading-controller';

// The Loading Component Tests card's body on the Test UI Components page: the full-screen loading
// overlay, once with fixed text and once with text that changes while it shows.
@Component({
  selector: 'cs-test-loading-card',
  host: { class: 'showcase-card-body' },
  template: `
    <cs-item-list>
      <cs-item>
        <cs-button item-right (click)="showLoading()" [label]="'Show Basic Loading (3s)' | untranslated"
          data-test="show-loading" fit-width>
        </cs-button>
      </cs-item>
      <cs-item>
        <cs-button item-right (click)="showLoadingWithChangingContent()"
          [label]="'Show Loading with Changing Content' | untranslated" data-test="show-loading-changing" fit-width>
        </cs-button>
      </cs-item>
    </cs-item-list>
  `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestLoadingCardComponent {
  constructor(private loadingCtrl: LoadingController) {}

  // Test Loading component
  async showLoading() {
    const loading = this.loadingCtrl.create({
      content: untranslatedString('Loading data...')
    });
    await loading.present();
    
    // Simulate async operation
    setTimeout(async () => {
      await loading.dismiss();
    }, 3000);
  }

  async showLoadingWithChangingContent() {
    const loading = this.loadingCtrl.create({
      content: untranslatedString('Step 1: Initializing...')
    });
    await loading.present();
    
    // Change content after 1 second
    setTimeout(() => {
      loading.setContent(untranslatedString('Step 2: Processing...'));
    }, 1000);
    
    // Change content again after 2 seconds
    setTimeout(() => {
      loading.setContent(untranslatedString('Step 3: Finalizing...'));
    }, 2000);
    
    // Dismiss after 3 seconds
    setTimeout(async () => {
      await loading.dismiss();
    }, 3000);
  }
}
